<template><div><h1>VUX V2.1.1Rc.8 发布日志</h1>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[enhance] 更新头部样式并新增 less 变量</li>
</ul>
<h2><a href="/zh-CN/components/tabbar.html">Tabbar</a></h2>
<ul><li>[feature] 支持点击时切换图标</li>
</ul>
<h2><a href="/zh-CN/components/x-header.html">XHeader</a></h2>
<ul><li>[fix] 修复过渡动画</li>
<li>[fix] 修复 返回文字 国际化</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[feature] 支持设置 placeholder 对齐方式</li>
</ul>
<h2><a href="/zh-CN/components/x-textarea.html">XTextarea</a></h2>
<ul><li>[feature] 支持title属性</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.8 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.8-214.vue?177f2ab4